fragment LeadValueFragment on Lead {
    valueMode
    value {
        amount
        formatted
        currency
    }
    products(first: 1000) {
        totalValue {
            formatted
        }
    }
}
